import { createAction, props } from '@ngrx/store';
import { ClientFeatureFlags, FeatureFlags } from '../models/model';

// Feature flags that tell which features are enabled 
export const loadFeatureFlags = createAction('[UI] Load Feature Flags', props<{ organizationId: string, clientIds: string[] }>());
export const loadFeatureFlagsSuccess = createAction('[UI] Load Feature Flags Success', props<{ featureFlags: ClientFeatureFlags }>());
